import {
    fetchCardStockDetailKSU,
    fetchCardStockKSU,
    fetchDataDetailHistoryInventoryKSU,
    fetchDataDetailInventoryKSU,
    fetchDataInventoryKSU, fetchDataMasterKSU,
    initialDataKSU,
    initialFilterDataKSU,
    initialSearchKSU,
    pageConfigKSU
} from "./config/configKSU";
import {
    fetchCardStockDetailGift,
    fetchCardStockGift,
    fetchDataDetailHistoryInventoryGift,
    fetchDataDetailInventoryGift,
    fetchDataInventoryHadiah,
    fetchDataMasterGift,
    initialDataHadiah,
    initialFilterDataHadiah,
    initialSearchHadiah,
    pageConfigHadiah
} from "./config/configHadiah";
import {
    fetchCardStockDetailOtherItem,
    fetchCardStockOtherItem,
    fetchDataDetailHistoryInventoryOtherItem,
    fetchDataDetailInventoryOtherItem,
    fetchDataInventoryOtherItem,
    fetchDataMasterOtherItem,
    initialDataOtherItem,
    initialFilterDataOtherItem,
    initialSearchOtherItem,
    pageConfigOtherItem
} from "./config/configOtherItem";
import Api from "../../../../Services/Api";
import {getValueFromDDL, mapToObjectDDL} from "../../../common/mapper";


export const getTableConfig = (type) => {
    switch (type) {
        case "ksu" :
            return pageConfigKSU.home.tableConfig;
        case "hadiah" :
            return pageConfigHadiah.home.tableConfig;
        case "otherItem" :
            return pageConfigOtherItem.home.tableConfig;
    }
}

export const getPageConfig = (type) => {
    switch (type) {
        case "ksu" :
            return pageConfigKSU;
        case "hadiah" :
            return pageConfigHadiah;
        case "otherItem" :
            return pageConfigOtherItem;
    }
}

export const getInitialData = (type) => {
    switch (type) {
        case "ksu" :
            return initialDataKSU;
        case "hadiah" :
            return initialDataHadiah;
        case "otherItem" :
            return initialDataOtherItem;
    }
}

export const getInitialFilterData = (type) => {
    switch (type) {
        case "ksu" :
            return initialFilterDataKSU;
            break;
        case "hadiah" :
            return initialFilterDataHadiah;
            break;
        case "otherItem" :
            return initialFilterDataOtherItem;
            break;
    }
}

export const getInitialSearchData = (type) => {
    switch (type) {
        case "ksu" :
            return initialSearchKSU;
        case "hadiah" :
            return initialSearchHadiah;
        case "otherItem" :
            return initialSearchOtherItem
    }
}

export const fetchData = async (type, setState, body) => {
    switch (type) {
        case "ksu" :
            return await fetchDataInventoryKSU(setState, body);
        case "hadiah" :
            return await fetchDataInventoryHadiah(setState, body);
        case "otherItem" :
            return await fetchDataInventoryOtherItem(setState, body);
    }
}

export const fetchDataDetail = async (type, setState, body, setError) => {
    switch (type) {
        case "ksu" :
            return await fetchDataDetailInventoryKSU(setState, body, setError);
        case "hadiah" :
            return await fetchDataDetailInventoryGift(setState, body, setError);
        case "otherItem" :
            return await fetchDataDetailInventoryOtherItem(setState, body, setError);
    }
}

export const fetchCardStock = async (type, setState, body, setError, selectedData) => {
    switch (type) {
        case "ksu" :
            return await fetchCardStockKSU(setState, body, setError);
        case "hadiah" :
            return await fetchCardStockGift(setState, body, setError, selectedData);
        case "otherItem" :
            return await fetchCardStockOtherItem(setState, body, setError, selectedData);
    }
};

export const fetchCardStockDetail = async (type, setState, body, setError, selectedParentData) => {
    switch (type) {
        case "ksu" :
            return await fetchCardStockDetailKSU(setState, body, setError);
        case "hadiah" :
            return await fetchCardStockDetailGift(setState, body, setError, selectedParentData);
        case "otherItem" :
            return await fetchCardStockDetailOtherItem(setState, body, setError, selectedParentData);
    }
};

export const fetchDataDetailHistory = async (type, setState, body, setError) => {
    switch (type) {
        case "ksu" :
            return await fetchDataDetailHistoryInventoryKSU(setState, body, setError);
        case "hadiah" :
            return await fetchDataDetailHistoryInventoryGift(setState, body, setError);
        case "otherItem" :
            return await fetchDataDetailHistoryInventoryOtherItem(setState, body, setError);
    }
}

export const fetchDataFilter = async (type, setState, reqBodyLocator) => {
    await fetchDataLocator(setState, reqBodyLocator);
    switch (type) {
        case "ksu" : {
            await fetchDataMasterKSU(setState);
            await fetchDataCategory(setState, "KSU_TYPE");
            return;
        }
        case "hadiah" : {
            await fetchDataMasterGift(setState);
            await fetchDataCategory(setState, "GIFT_TYPE");
            return
        }
            ;
        case "otherItem" : {
            await fetchDataMasterOtherItem(setState);
            await fetchDataCategory(setState, "OTHER_ITEMS_TYPE");
            return
        }
            ;
    }
}

export const parseFilterData = (type, filterData) => {
    switch (type) {
        case "ksu" : {
            return {
                ...filterData,
                kodeKSU: getValueFromDDL(filterData, "kodeKSU"),
                categoryKSU: getValueFromDDL(filterData, "categoryKSU"),
                kodeLocator: getValueFromDDL(filterData, "kodeLocator"),
                kodeCabang: [getValueFromDDL(filterData, "kodeCabang")],
                umur: parseInt(filterData.umur),
            };
        }
            ;
        case "hadiah" :
            {
                return {
                    ...filterData,
                    giftCode: getValueFromDDL(filterData, "giftCode"),
                    giftCategory: getValueFromDDL(filterData, "giftCategory"),
                    kodeLocator: getValueFromDDL(filterData, "kodeLocator"),
                    kodeCabang: [getValueFromDDL(filterData, "kodeCabang")]
                };
            }
        case "otherItem" :
            {
                return {
                    ...filterData,
                    otherItemCode: getValueFromDDL(filterData, "otherItemCode"),
                    otherCategoryValue: getValueFromDDL(filterData, "otherCategoryValue"),
                    locatorName: getValueFromDDL(filterData, "locatorName"),
                    kodeCabang: [getValueFromDDL(filterData, "kodeCabang")],
                    nameotheritem: filterData.nameotheritem
                };
            }
    }
}

export const getOptiosDDL = (state, name) => {
    switch (name) {
        case "kodeKSU":
            return state.dataKSUDDL.map(item => mapToObjectDDL(item.kodeKSU, item.kodeKSU));
        case "categoryKSU":
            return state.dataCategoryDDL.map(item => mapToObjectDDL(item.value, item.key));
        case "kodeLocator":
            return state.dataLocatorDDL.map(item => mapToObjectDDL(item.nameLocation, item.kodeLocation));
        case "giftCode":
            return state.dataGiftDDL.map(item => mapToObjectDDL(item.kodeHadiah, item.kodeHadiah));
        case "giftCategory":
            return state.dataCategoryDDL.map(item => mapToObjectDDL(item.value, item.key));
         case "otherItemCode":
            return state.dataOtherItemDDL.map(item => mapToObjectDDL(item.kodeotheritem, item.kodeotheritem));
        case "otherCategoryValue":
            return state.dataCategoryDDL.map(item => mapToObjectDDL(item.value, item.key));
        case "locatorName":
            return state.dataLocatorDDL.map(item => mapToObjectDDL(item.nameLocation, item.kodeLocation));
    }
}

export const setInputValue = (name, state, filterData) => {
    switch (name) {
        case "nameKSU": {
            let kodeKSU = filterData.kodeKSU ? filterData.kodeKSU.value : null;
            let dataKSU = state.dataKSUDDL.find(item => item.kodeKSU === kodeKSU)
            return dataKSU ? dataKSU.name : null;
        };
        case "giftName": {
            let kodeHadiah = filterData.giftCode ? filterData.giftCode.value : null;
            let dataGift  = state.dataGiftDDL.find(item => item.kodeHadiah === kodeHadiah)
            return dataGift  ? dataGift.nameHadiah : null;
        };
        case "otherItemName": {
            let kodeotheritem = filterData.otherItemCode ? filterData.otherItemCode.value : null;
            let dataOtherItem  = state.dataOtherItemDDL.find(item => item.kodeotheritem === kodeotheritem)
            return dataOtherItem  ? dataOtherItem.nameotheritem : null;
        };
        default:
            return filterData[name];
    }
}


// fetch data global
export const fetchDataCategory = async (setState, bizparCategory) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam({
            paramFilters: {bizparCategory: bizparCategory}
        });

        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCategoryDDL: response.data.data,
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const fetchDataLocator = async (setState, body) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterLocationPagingByParam(body)
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataLocatorDDL: response.data.data,
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const getTableHistoryConfig = (type) => {
    const baseRenderOptions = {
        customBodyRender: (value) => value ? value : "-",
        sort: false,
    };

    switch (type) {
        case "ksu":
            return [
                { name: "transactionDate", label: "Tgl. Transaksi", options: baseRenderOptions },
                { name: "transactionHour", label: "Jam", options: baseRenderOptions },
                { name: "historyFixing", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "refDocNo", label: "Ref. Doc No.", options: baseRenderOptions },
                { name: "kodeLocator", label: "Locator", options: baseRenderOptions },
                { name: "kodeCabang", label: "Kd. Cabang", options: baseRenderOptions },
            ];
        case "hadiah":
            return [
                { name: "date", label: "Tgl. Transaksi", options: baseRenderOptions },
                { name: "hour", label: "Jam", options: baseRenderOptions },
                { name: "trxCode", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "trxId", label: "Ref. Doc No.", options: baseRenderOptions },
                { name: "locator", label: "Locator", options: baseRenderOptions },
                { name: "kodeCabang", label: "Kd. Cabang", options: baseRenderOptions },
            ];
        case "otherItem":
            return [
                { name: "date", label: "Tgl. Transaksi", options: baseRenderOptions },
                { name: "hour", label: "Jam", options: baseRenderOptions },
                { name: "trxCode", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "trxId", label: "Ref. Doc No.", options: baseRenderOptions },
                { name: "nameLocator", label: "Locator", options: baseRenderOptions },
                { name: "kodeCabang", label: "Kd. Cabang", options: baseRenderOptions },
            ];
        default:
            return [];
    }
}

export const getTableStockCardDetailConfig = (type, selectedData) => {
    const baseRenderOptions = {
        customBodyRender: (value) => (value ? value : "-"),
        sort: false,
    };

    switch (type) {
        case "ksu":
            return [
                { name: "qrCode", label: "QR Code", options: baseRenderOptions },
                { name: "transactionCode", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "trxId", label: "Doc. No", options: baseRenderOptions }
            ];

        case "hadiah":
            if (selectedData?.qr === true) {
                return [
                    { name: "barcode", label: "QR Code", options: baseRenderOptions },
                    { name: "trxCode", label: "Jenis Transaksi", options: baseRenderOptions },
                    { name: "trxId", label: "Doc. No", options: baseRenderOptions }
                ];
            }

            return [
                { name: "trxCode", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "qty", label: "Jumlah", options: baseRenderOptions },
                { name: "trxId", label: "Doc. No", options: baseRenderOptions }
            ];

        case "otherItem":
            if (selectedData?.barcode === true) {
                return [
                    { name: "barcode", label: "QR Code", options: baseRenderOptions },
                    { name: "trxCode", label: "Jenis Transaksi", options: baseRenderOptions },
                    { name: "trxId", label: "Doc. No", options: baseRenderOptions }
                ];
            }

            return [
                { name: "trxType", label: "Jenis Transaksi", options: baseRenderOptions },
                { name: "qty", label: "Jumlah", options: baseRenderOptions },
                { name: "trxId", label: "Doc. No", options: baseRenderOptions }
            ];

        default:
            return [];
    }
};
